var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"cursor",class:{'over-target': !!_vm.hoverTarget},style:(_vm.style)},[_c('div',{staticClass:"circle"})])}
var staticRenderFns = []

export { render, staticRenderFns }